"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _clickawayListener = _interopRequireDefault(require("../_clickaway-listener"));

var _popover = require("../_popover");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n            opacity: 1;\n            visibility: visible;\n          "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          width: 100%;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          margin-top: 7px;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  pointer-events: ", ";\n  ", ";\n  ", ";\n  > ", " {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContentPopover = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.contentDisabled ? 'none' : 'auto';
}, function (props) {
  return props.adjustVerticalAlign ? (0, _styledComponents.css)(_templateObject2()) : (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.fullWidth ? (0, _styledComponents.css)(_templateObject4()) : (0, _styledComponents.css)(_templateObject5());
}, _popover.StyledPopover, function (props) {
  return props.open ? (0, _styledComponents.css)(_templateObject6()) : (0, _styledComponents.css)(_templateObject7());
});

var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popover, _React$Component);

  //eslint-disable-line
  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getAlignmentAndPosition", function (_ref) {
      var align = _ref.align,
          position = _ref.position;

      var _this$node$getBoundin = _this.node.getBoundingClientRect(),
          left = _this$node$getBoundin.left,
          top = _this$node$getBoundin.top,
          right = _this$node$getBoundin.right,
          bottom = _this$node$getBoundin.bottom;

      var viewportWidth = window.innerWidth;
      var viewportHeight = window.innerHeight;
      right = viewportWidth - right;
      bottom = viewportHeight - bottom;

      if (align === 'left') {
        if (left <= 0) align = 'right';
      } else if (align === 'right') {
        if (right <= 0) align = 'left';
      }

      if (position === 'top') {
        if (top <= 0) position = 'bottom';
      } else {
        if (bottom <= 0) position = 'top';
      }

      return {
        align: align,
        position: position
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getChildRef", function (child) {
      _this.trigger = child;
    });

    _defineProperty(_assertThisInitialized(_this), "getPopoverAlignment", function (position, align) {
      if (align !== 'middle') return;
      var isOnXaxis = position === 'left' || position === 'right';

      if (isOnXaxis) {
        var triggerHeight = _this.trigger.offsetHeight;
        var popoverHeight = _this.node.offsetHeight;
        _this.node.style.top = "".concat((triggerHeight - popoverHeight) / 2, "px");
      } else {
        var triggerWidth = _this.trigger.offsetWidth;
        var popoverWidth = _this.node.offsetWidth;
        _this.node.style.left = "".concat((triggerWidth - popoverWidth) / 2, "px");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      var _this$getAlignmentAnd = _this.getAlignmentAndPosition({
        align: _this.state.align,
        position: _this.state.position
      }),
          align = _this$getAlignmentAnd.align,
          position = _this$getAlignmentAnd.position;

      if (_this.state.isOpen) {
        _this.getPopoverAlignment(position, align);
      }

      if (prevState.align === align && prevState.position === position) {
        return;
      }

      _this.setState(function (state) {
        return _objectSpread({}, state, {
          align: align,
          position: position
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$getAlignmentAnd2 = _this.getAlignmentAndPosition(_this.props),
          align = _this$getAlignmentAnd2.align,
          position = _this$getAlignmentAnd2.position;

      _this.setState({
        align: align,
        position: position
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      if (_this.props.open !== nextProps.open) {
        _this.setState(function (state) {
          return _objectSpread({}, state, {
            isOpen: nextProps.open
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickAway", function (event) {
      if (_this.state.isOpen) {
        _this.setState(function (state) {
          return _objectSpread({}, state, {
            isOpen: false
          });
        }, _this.props.onClose);
      }
    });

    var _align = props.align,
        _position = props.position;
    _this.state = {
      isOpen: props.open,
      align: _align,
      position: _position
    };
    return _this;
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          fullWidth = _this$props.fullWidth,
          adjustVerticalAlign = _this$props.adjustVerticalAlign,
          contentDisabled = _this$props.contentDisabled,
          content = _this$props.content,
          children = _this$props.children,
          popOverClass = _this$props.popOverClass;

      var childWithRef = _react["default"].cloneElement(children, {
        innerRef: this.getChildRef
      });

      return _react["default"].createElement(_clickawayListener["default"], {
        onClickAway: this.onClickAway
      }, _react["default"].createElement(ContentPopover, {
        open: this.state.isOpen,
        fullWidth: fullWidth,
        adjustVerticalAlign: adjustVerticalAlign,
        contentDisabled: contentDisabled
      }, _react["default"].createElement(_popover.StyledPopover, _extends({}, this.props, {
        align: this.state.align,
        position: this.state.position,
        innerRef: function innerRef(el) {
          return _this2.node = el;
        },
        className: popOverClass
      }), content), childWithRef));
    }
  }]);

  return Popover;
}(_react["default"].Component);

Popover.propTypes = {
  onClose: _propTypes["default"].func,
  align: _propTypes["default"].oneOf(['left', 'middle', 'right', 'top', 'bottom']),
  pointer: _propTypes["default"].bool,
  position: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  fullWidth: _propTypes["default"].bool,
  popOverClass: _propTypes["default"].string,
  adjustVerticalAlign: _propTypes["default"].bool
};
Popover.defaultProps = {
  onClose: _noop2["default"],
  align: 'right',
  pointed: false,
  position: 'bottom',
  fullWidth: false,
  adjustVerticalAlign: true
};
Popover.displayName = 'Popover';

var _default = (0, _context.withVersion)(Popover);

exports["default"] = _default;